// Product card behaviour (snippets/card-product.liquid).
//
// <card-swatches> — colour swatches rendered on a product card. Each child button carries the
// variant it stands for (data-variant-id, data-variant-url) and, when that variant has its own
// image, data-image-src / data-image-srcset / data-image-width / data-image-height. Clicking a
// swatch marks it active, swaps the card's primary image to the variant image, points the card
// links at the variant URL and updates the quick-add form's variant id so "Add to cart" adds the
// chosen colour. Keyboard: the buttons are real <button>s, so Enter/Space work out of the box.
(() => {
  const define = (window.Multiverse && Multiverse.defineOnce) || ((name, cls) => {
    if (!customElements.get(name)) customElements.define(name, cls);
  });

  class CardSwatches extends HTMLElement {
    connectedCallback() {
      this.card = this.closest('.card-wrapper');
      this.onClick = this.onClick || ((event) => {
        const swatch = event.target.closest('.mv-swatch');
        if (!swatch || !this.contains(swatch)) return;
        event.preventDefault();
        this.select(swatch);
      });
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    select(swatch) {
      this.querySelectorAll('.mv-swatch.is-active').forEach((el) => el.classList.remove('is-active'));
      swatch.classList.add('is-active');
      if (!this.card) return;

      const { variantId, variantUrl, imageSrc, imageSrcset, imageWidth, imageHeight } = swatch.dataset;

      if (imageSrc) {
        const img = this.card.querySelector('.card__media .card__primary-image');
        if (img && img.getAttribute('src') !== imageSrc) {
          img.setAttribute('src', imageSrc);
          if (imageSrcset) img.setAttribute('srcset', imageSrcset);
          if (imageWidth) img.setAttribute('width', imageWidth);
          if (imageHeight) img.setAttribute('height', imageHeight);
        }
      }

      if (variantUrl) {
        this.card.querySelectorAll('a.card__link, a[data-card-link]').forEach((link) => link.setAttribute('href', variantUrl));
        this.card.querySelectorAll('[data-product-url]').forEach((el) => el.setAttribute('data-product-url', variantUrl));
      }

      if (variantId) {
        const formId = this.dataset.formId;
        const form = formId ? this.card.querySelector(`#${CSS.escape(formId)}`) : null;
        const input = form ? form.querySelector('input[name="id"]') : null;
        if (input) input.value = variantId;
        const unavailable = swatch.classList.contains('mv-swatch--unavailable');
        const submit = form ? form.querySelector('[type="submit"]') : null;
        if (submit) {
          submit.toggleAttribute('disabled', unavailable);
          const label = submit.querySelector('span:not(.sold-out-message)');
          const soldOut = submit.querySelector('.sold-out-message');
          if (label && soldOut) {
            if (unavailable) {
              label.dataset.label = label.dataset.label || label.textContent;
              label.textContent = soldOut.textContent.trim();
            } else if (label.dataset.label) {
              label.textContent = label.dataset.label;
            }
          }
        }
      }
    }
  }

  define('card-swatches', CardSwatches);
})();
